<template>
    <v-row class="pa-2">

        <v-col cols="12">
            <v-text-field dense outlined hide-details color="primary" v-model="participantName"
                          prepend-icon="mdi-account"
                          label="Participant Username"></v-text-field>
        </v-col>
        <v-col cols="12">
            <v-text-field dense outlined hide-details color="primary" v-model="resultID"
                          prepend-icon="mdi-file-document-box"
                          label="Result ID"></v-text-field>
        </v-col>

        <v-col cols="12">
            <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="290px">
                <template v-slot:activator="{ on }">
                    <v-text-field dense outlined hide-details
                                  v-model="date"
                                  label="Assessment Date"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-on="on"
                    ></v-text-field>
                </template>
                <v-date-picker @input="$refs.menu.save(date)" v-model="date" no-title color="primary" scrollable>
                </v-date-picker>
            </v-menu>
        </v-col>

        <v-col cols="12">
            <v-checkbox color="primary" v-model="includeUnfinished" label="Include Unfinished"></v-checkbox>
        </v-col>

        <v-col class="pa-2">
            <v-btn depressed :disabled="!canSearch"
                   @click="handleSearch" ripple block :light="canSearch" color="primary">
                Search
            </v-btn>
            <v-subheader class="caption" small v-if="!canSearch">Enter a Username, Result ID or Date to search.
            </v-subheader>
        </v-col>

    </v-row>
</template>

<script>
  import {mapActions, mapMutations, mapGetters} from 'vuex'

  export default {
    name: 'MarkingListSearch',

    computed: {
      canSearch() {
        if (this.date === null && this.participantName === '' && this.resultID === '') {
          return false
        }
        return true
      }
    },

    data() {
      return {
        participantName: '',
        resultID: '',
        includeUnfinished: false,
        menu: false,
        date: null
      }
    },

    methods: {
      ...mapMutations(['SET_FIND_DATE', 'SET_FIND_PARTICIPANT', 'SET_FIND_RESULT_ID', 'SET_FIND_INCLUDE_SCORED']),
      ...mapActions(['FETCH_PARTICIPANT_RESULTS']),
      handleSearch() {
        this.FETCH_PARTICIPANT_RESULTS({
          participant: this.participantName,
          resultID: this.resultID,
          includeUnfinished: this.includeUnfinished,
          whenFinished: this.date
        });
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
